import { ChangeEventHandler, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TradeCategoryForm from "../../components/admin/TradeCategoryForm";
import AdminLayout from "../../components/custom/layouts/AdminLayout";
//import { ActiveTypes, TradeCategoryType } from '../../redux/actions/tradeCategoryActions'
//import { AppDispatch, StoreState } from '../../redux/store'
//import { deleteTradeCategory } from "../../redux/actions/tradeCategoryActions"
import { nanoid } from "@reduxjs/toolkit";
import Modal from "../../components/Modal";
import  {
  Tbody,
  Thead,
} from "../../components/custom/components/AdminTable";
import { ToastTypes, useToast } from "../../components/toast/ToastProvider";
import { FormType, FormTypeList } from "../../config";
import {
  TradeCategoryType,
  deleteTradeCategory,
  fetchTradeCategory,
} from "../../redux/actions/tradeCategoryActions";
import { AppDispatch, StoreState } from "../../redux/store";
import DeleteConfirmationForm from "../../components/admin/DeleteConfirmationForm";
import { TradeSubCategoryType } from "../../redux/actions/tradeSubCategoryActions";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import AdminTable2 from "../../components/custom/components/AdminTable2";
import { AuthAdminType } from "../../redux/actions/authAdminActions";
import { AdminLog } from "../../config/common";

// interface TableBody {
//     sno: number
//     name: string
//     active: ActiveTypes | boolean
//     onEdit: MouseEventHandler<HTMLButtonElement>
//     onDelete: MouseEventHandler<HTMLButtonElement>
//     onView: MouseEventHandler<HTMLButtonElement>
// }

// type HandleEdit = (value: TradeCategoryType) => void
type HandleDelete = (value: TradeCategoryType) => void;
// type HandleView = (value: TradeCategoryType) => void

const TradeCategory = () => {
  const toast = useToast();
  const dispatch = useDispatch<AppDispatch>();
   const navigate = useNavigate();
  const pageName = useLocation()
  const authAdmin = useSelector<StoreState, AuthAdminType | null>(
    (state) => state.authAdmin
  );
  const adminAuthendicated =
  typeof authAdmin?.["auth-token"] === "string" &&
  authAdmin?.["auth-token"] !== undefined &&
  authAdmin?.["auth-token"] !== "";
  const TradeCategoryList = useSelector<StoreState, Array<TradeCategoryType>>(
    (state) => state.tradeCategory
  );
  const TradeSubCategoryList = useSelector<
    StoreState,
    Array<TradeSubCategoryType>
  >((state) => state.tradeSubCategory);

  const [showForm, setShowForm] = useState<boolean>(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] =
    useState<boolean>(false);
  const [formType, setFormType] = useState<FormType>(FormTypeList.ADD);
  const [editData, setEditData] = useState<TradeCategoryType>();
  const [deleteData, setDeleteData] = useState<TradeCategoryType>();
  const [showViewForm, setShowViewForm] = useState<boolean>(false);
  const [disableDelete, setDisableDelete] = useState<boolean>(false);
  const [id, setId] = useState<number>();

  const [searchQuery, setSearchQuery] = useSearchParams();
  const searchTerm = searchQuery.get("search") || "";

  const searchCatHandler = (cat: TradeCategoryType, searchTerm: string) => {
    return searchTerm !== ""
      ? new RegExp(`^${searchTerm}|${searchTerm}`, "gi").test(cat.name)
      : true || [];
  };

  const searchHandler: ChangeEventHandler<HTMLInputElement> = (e) => {
    setSearchQuery({ search: e.target.value });
  };

  const [tradeCategoryData, setTradeCategoryData] = useState<
    TradeCategoryType[]
  >([]);

  const limit = 20;
  const [offset, setOffset] = useState<number>(0);
  const [range, setRange] = useState<number[]>([]);
  const [length, setLength] = useState<number>(0);

  useEffect(() => {
    if (TradeCategoryList?.length > 0) {
      setLength(TradeCategoryList?.length ? TradeCategoryList?.length : 0);
    }
  }, [TradeCategoryList]);

  const handleApply = async (offsetVal = offset) => {
    if (TradeCategoryList?.length > 0) {
      const getData = {
        limit: limit?.toString(),
        offset: offsetVal?.toString(),
      };

      if (
        getData !== undefined &&
        getData.limit !== "" &&
        getData.offset !== "" &&
        getData.offset !== undefined &&
        getData.offset !== "NaN"
      ) {
        const filteredTradeCategoryList: TradeCategoryType[] =
          TradeCategoryList?.slice(offset, limit + offset);
        if (filteredTradeCategoryList?.length > 0) {
          setTradeCategoryData([...filteredTradeCategoryList]);
        } else {
          setTradeCategoryData([]);
        }
      }
    }
  };

  useEffect(() => {
    handleApply();
  }, [TradeCategoryList]);

    useEffect(()=>{
     navigate("/admin/trade_category");
  },[])

  const getTableData = () => {
    var tableHead: Thead[] = [
      { id: "S.No", children: "S.No", text: "S.No" },
      { id: "Name", children: "Name", text: "Name" },
      { id: "Status", children: "Status", text: "Status" },
      { id: "Action", children: "Action", text: "Action" },
    ];
    var tableBody: Tbody[][] = [];

    tradeCategoryData
      .filter((cr) => searchCatHandler(cr, searchTerm))
      .forEach((item, i) => {
        const pageNumber = Math.floor(offset / limit) + 1;
        var tBody: Tbody[] = [];

        tBody.push(
          {
            id: nanoid(),
            theadId: "S.No",
            children: limit * pageNumber + i - limit + 1,
            text: (limit * pageNumber + i - limit + 1)?.toString(),
          },
          {
            id: nanoid(),
            theadId: "Name",
            children: item.name,
            text: item.name,
            className: "text-truncate",
          },
          {
            id: nanoid(),
            theadId: "Status",
            children: item.active ? "Active" : !item.active ? "InActive" : "",
            text: item.active ? "Active" : !item.active ? "InActive" : "",
          },
          {
            id: nanoid(),
            theadId: "Action",
            children: "action",
            className: "d-none",
            text: item.id?.toString(),
          }
        );
        tableBody.push(tBody);
        // })
      });

    return { tbody: tableBody, thead: tableHead };
  };
  const handleAdd = () => {
    setShowForm(true);
    if(adminAuthendicated){
      const logProps1 = {
        action: 'Create',
        event: `${pageName.pathname.replace("\\", " ")} page | Create Trade Category Clicked`
      };
      AdminLog(logProps1)
    }
  };

  const handleView = () => {
    setFormType(FormTypeList.VIEW);
    if (id !== undefined) {
      var obj = TradeCategoryList.find((c) => c.id === id);
      setShowForm(true);
      setEditData(obj);
      setShowViewForm(true);
      if(adminAuthendicated){
        const logProps1 = {
          action: 'View',
          event: `${pageName.pathname.replace("\\", " ")} page |  ${obj?.name} TradeCategory Viewed | View Clicked`
        };
        AdminLog(logProps1)
      }
    }
  };

  const handleDeleteConfirmation = () => {
    setFormType(FormTypeList.DELETE);
    if (id !== undefined) {
      var obj = TradeCategoryList.find((c) => c.id === id);
      setShowDeleteConfirmation(true);
      const tradeSubCategories = TradeSubCategoryList.filter(
        (tsc) => tsc.catid === id
      );
      setDeleteData(obj);
      setDisableDelete(tradeSubCategories?.length ? true : false);
    }
  };

  const handleEdit = () => {
    setFormType(FormTypeList.EDIT);
    if (id !== undefined) {
      var obj = TradeCategoryList.find((c) => c.id === id);
      setEditData(obj);
      setShowForm(true);
      if(adminAuthendicated){
        const logProps1 = {
          action: 'Edit',
          event: `${pageName.pathname.replace("\\", " ")} page | TradeCategory - ${obj?.name} | Edit Clicked`
        };
        AdminLog(logProps1)
      }
    }
  };

  const handleDelete: HandleDelete = (value) => {
    if (value.id !== undefined) {
      dispatch(deleteTradeCategory(value.id))
        .then(async (text) => {
          dispatch(fetchTradeCategory());
          toast(text, ToastTypes.SUCCESS);
          if (
            tradeCategoryData !== undefined &&
            tradeCategoryData?.length === 1
          ) {
            let newOffset = offset - limit < 0 ? 0 : offset - limit;
            setOffset(newOffset);
            await handleApply(newOffset);
          } else {
            await handleApply(); //issue starts from here
          }
          handleFormClose();
        })
        .catch((text) => {});
    }
  };

  const handleFormClose = () => {
    setShowForm(false);
    setFormType(FormTypeList.ADD);
    setEditData(undefined);
    setId(undefined);
    setShowViewForm(false);
    setShowDeleteConfirmation(false);
  };

  useEffect(() => {
    if (id !== undefined && formType === FormTypeList.VIEW) handleView();
    else if (id !== undefined && formType === FormTypeList.EDIT) handleEdit();
    else if (id !== undefined && formType === FormTypeList.DELETE)
      handleDeleteConfirmation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, formType]);

  useEffect(() => {
    var range = [];
    var num = Math.ceil(length / limit);
    // let i = 1;

    for (let i = 1; i <= num; i++) {
      range.push(i);
    }

    setRange(range);
  }, [length, limit]);

  useEffect(()=>{
    if(adminAuthendicated){
    const logProps1 = {
      action:`Visit`,
      event: `${pageName.pathname.replace("\\", " ")} page | Visited `
    };
    AdminLog(logProps1)
  }
  },[])

  return (
    <>
      <Modal
        headerText={formType + " TRADE CATEGORY"}
        visible={showForm}
        onClose={handleFormClose}
        size="xl"
        centered
      >
        <TradeCategoryForm
          formType={formType}
          editData={editData}
          onSave={handleFormClose}
          showViewForm={showViewForm}
        />
      </Modal>
      <Modal
        headerText={formType + " TRADE CATEGORY"}
        visible={showDeleteConfirmation}
        onClose={handleFormClose}
        size="lg"
        centered
      >
        <DeleteConfirmationForm
          deleteLabel={
            disableDelete
              ? "Trade category is in use. Deletion not allowed."
              : "Do you really want to delete the records with the Trade Category - " +
                deleteData?.name
          }
          onCancel={handleFormClose}
          onDelete={() => (disableDelete ? {} : handleDelete(deleteData!))}
        />
      </Modal>
      <AdminLayout>
        {/* <PageTitle
                title='Trade Category Management'
                buttonText='Create Trade Category'
                onButtonClick={handleAdd}
            /> */}
        <AdminTable2
          addBtnText="Create New Trade Category"
          onAdd={handleAdd}
          onEdit={handleEdit}
          onDelete={handleDeleteConfirmation}
          onView={handleView}
          search={searchHandler}
          limit={limit}
          setOffset={setOffset}
          offset={offset}
          onPageNoChange={handleApply}
          range={range}
          pageTitle="Trade Category Management"
          path="/admin/trade_category"
          // data={data}
          setId={setId}
          {...getTableData()}
        />
        {/* <div className="card mt-3">
                <div className="card-body">
                    <div className='row'>
                        <div className="col-lg-6 col-sm-12">
                            <h5 className="header-title mb-3 float-start"><i className="fe-align-justify me-1 text-primary"></i>Trade Category Management</h5>
                        </div>
                        <div className="col-lg-6 col-sm-12 text-end mb-1">
                            <button type="button" onClick={handleAdd} className={`me-1 btn btn-xs btn-secondary`}>Create New Trade Category</button>
                        </div>
                    </div>
                    <hr className='hr mt-0' />
                    <div className='table-wrapper'>
                        <table className='table colored'>
                            <thead>
                                <tr>
                                    <th className='text-truncate align-middle'>S.No</th>
                                    <th className='text-truncate align-middle'> Name</th>
                                    <th className='text-truncate align-middle'>Status</th>
                                    <th className='text-truncate align-middle'>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {TradeCategoryList.map((u, i) => {
                                    return <TradeCategoryBody
                                        sno={i + 1}
                                        name={u.name}
                                        active={u.active}
                                        key={i}
                                        onEdit={() => handleEdit(u)}
                                        onDelete={() => handleDelete(u)}
                                        onView={() => handleView(u)}
                                    />
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div> */}
      </AdminLayout>
    </>
  );
};

// const TradeCategoryBody = ({ sno, name, active, onView, onEdit, onDelete }: TableBody) => {
//     return <tr>
//         <td className='align-middle'>{sno}</td>
//         <td className='align-middle'>{name}</td>
//         <td className='align-middle'>{active ? "Active" : "InActive"}</td>
//         <td>
//             <div className='hstack gap-1'>
//                 <button className='btn btn-sm btn-secondary' onClick={onEdit}>Edit</button>
//                 <button className='btn btn-sm btn-secondary' onClick={onDelete}>Delete</button>
//                 <button className='btn btn-sm btn-secondary' onClick={onView}>View</button>
//             </div>
//         </td>
//     </tr>
// }

export default TradeCategory;
